import {
  Shoes,
  BlackDumbell,
  DistanceWalked,
  Fire,
  MuscleMass,
  FatFreeWeight,
  BloodPressure,
  HeartRate,
  BodyFatPercentage,
  BMI,
  Weight,
  SleepDuration,
} from "@utils/defaultImages";

export const getStatCards = (summary = {}) => {
  return [
    {
      label: "Total Steps",
      value: summary?.totalSteps ?? 0,
      color: "#FFF7F0",
      icon: <Shoes />,
    },
    {
      label: "Active Time",
      value: summary?.activeTime ?? "0m",
      color: "#F4F4F4",
      icon: <BlackDumbell />,
    },
    {
      label: "Distance",
      value: summary?.distance ?? "0 km",
      color: "#F4FFF0",
      icon: <DistanceWalked />,
    },
    {
      label: "Calories Burnt",
      value: summary?.caloriesBurnt ?? 0,
      color: "#FFFAF0",
      icon: <Fire />,
    },
  ];
};

export const getDeviceCards = (summary = {}) => {
  return [
    {
      label: "Sleep duration",
      value: summary?.sleep_minutes,
      color: "#F0FFFF",
      icon: <SleepDuration />,
    },
    {
      label: "Weight",
      value: summary?.weight,
      color: "#FFF0FB",
      icon: <Weight />,
    },
    {
      label: "Body Fat %",
      value: summary?.body_fat_percentage,
      color: "#FDFFF0",
      icon: <BodyFatPercentage />,
    },
    {
      label: "Muscle Mass",
      value: summary?.muscle_mass_kg,
      color: "#F0F5FF",
      icon: <MuscleMass />,
    },
    {
      label: "Fat-Free Weight",
      value: summary?.fat_free_mass_kg,
      color: "#FEF0FF",
      icon: <FatFreeWeight />,
    },
    {
      label: "BMI",
      value: summary?.bmi,
      color: "#F0FFF4",
      icon: <BMI />,
    },
    {
      label: "Heart Rate",
      value: summary?.heart_rate,
      color: "#FFF6F0",
      icon: <HeartRate />,
    },
    {
      label: "Blood Pressure",
      value: summary?.blood_pressure,
      color: "#FFF0F0",
      icon: <BloodPressure />,
    },
  ];
};
